import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import './App.css';
import {
  makeStyles,
  CssBaseline,
  createTheme,
  ThemeProvider,
} from '@material-ui/core';
import Header from './components/Header';
import {
  Login,
  Subscriptions,
  Resources,
  PrivateRoute,
  Error,
  LoginRoute,
} from './pages';

const theme = createTheme({
  palette: {
    primary: {
      main: '#333996',
      light: '#3c44b126',
    },
    secondary: {
      main: '#f83245',
      light: '#f8324526',
    },
    background: {
      default: '#f4f5fd',
    },
  },
  overrides: {
    MuiAppBar: {
      root: {
        transform: 'translateZ(0)',
      },
    },
  },
  props: {
    MuiIconButton: {
      disableRipple: true,
    },
  },
});

const useStyles = makeStyles({
  appMain: {
    width: '100%',
  },
});

function App() {
  const classes = useStyles();

  return (
    <ThemeProvider theme={theme}>
      <div className={classes.appMain}>
        <Router>
          <Switch>
            <LoginRoute exact path='/'>
              <Login />
            </LoginRoute>
            <PrivateRoute exact path='/abonnements'>
              <Header />
              <Subscriptions />
            </PrivateRoute>
            <PrivateRoute exact path='/ressources'>
              <Header />
              <Resources />
            </PrivateRoute>
            <PrivateRoute exact path='/resources'>
              <Header />
              <Resources />
            </PrivateRoute>
            <Route path='*'>
              <Header />
              <Error />
            </Route>
          </Switch>
        </Router>
      </div>
      <CssBaseline />
    </ThemeProvider>
  );
}

export default App;
